import { Flex, Box, Text, HTMLChakraProps, Skeleton, SkeletonOptions, forwardRef } from '@chakra-ui/react';
import { FC } from 'react';

export interface IOverviewCounterItem {
  name: string;
  value: string;
}

interface IOverviewCounterProps extends HTMLChakraProps<'div'> {
  items: Array<IOverviewCounterItem>;
}

export const OverviewCounter = forwardRef<IOverviewCounterProps, 'div'>(function OverviewCounter(
  { items, ...props },
  ref
) {
  return (
    <Flex flexDirection="row" flexWrap="wrap" w="full" {...props}>
      {items.map(({ name, value }) => (
        <Box key={name} mr={[8, null, 12, 16]} mb={5} _last={{ mr: 0 }}>
          <Text
            m={0}
            fontWeight="bold"
            fontFamily="heading"
            fontSize={['1.5rem', null, null, '2rem']}
            lineHeight={[8, null, null, 10]}
          >
            {value}
          </Text>
          <Text m={0}>{name}</Text>
        </Box>
      ))}
    </Flex>
  );
});

export const OverviewCounterSkeleton: FC<SkeletonOptions> = (props) => {
  return (
    <Flex flexDirection="row" flexWrap="wrap" w="full" {...props}>
      {Array.from({ length: 5 }, (_, i) => (
        <Skeleton key={i} mr={[8, null, 12, 16]} mb={5} w="40px" h="20" />
      ))}
    </Flex>
  );
};
